import { Component, OnInit, Output,EventEmitter,Input } from '@angular/core';
import { FormControl, FormGroup, Validators,FormBuilder } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { NotifierService } from 'angular-notifier';
import {Router} from '@angular/router';
import {Usuario,DireccionArea,DireccionGral} from 'src/app/interfaces/interfaces';
import{ ConfirmComponent} from 'src/app/components/shared/confirm/confirm.component';
import {MatDialogModule, MatDialog} from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';




@Component({
  selector: 'app-modal-usuario',
  templateUrl: './modal-usuario.component.html',
  styleUrls: ['./modal-usuario.component.scss']
})


export class ModalUsuarioComponent implements OnInit {
  formUsuariosAgregar: FormGroup;
  formUsuarioBuscar:FormGroup;
  rolesUsuario: { id_rol: number; nombre_rol: string; }[];
  rolesSeleccionados: string[] = [];
  opcionAdministracion: number = 1;
  mostrarFormularioAgregar: boolean = false;
  //Lista de jefaturas 
  listaJefaturas:{id_jefatura:number; nombre_jefatura:string}[];
  listaSubsecretarias:{id_subsecretariaSap:number; nombre_subsecretariaSap:string}[];

  //Variable para mostrar o no el combo de jefatura
  mostrarJefatura : boolean=false;
  //Variable para mostrar el combo de subsecretaria
  mostrarSubsecretaria:boolean=false;
  //Mostrar boton de búsqueda
  mostrarBtnBusqueda:boolean=true;
  mostrarFormBusqueda:boolean=true;
  //Variable de salida 
  @Output()botonCancelar = new EventEmitter<boolean>();
  cadena:string;
  direccionesGral: DireccionGral[];
  direccionesGralbySubse: DireccionGral[];
  direccionesArea: DireccionArea[];
  areaGralSeleccionada: string;
  emailUser:string;
  subsecretaria:number;
  loadingGeneral: boolean = false;

  
  get fa() { // acceso a la form para insertar usuarios
    return this.formUsuariosAgregar.controls;
  }
  get fag() { // acceso a la form para insertar usuarios
    return this.formUsuariosAgregar;
  }

  get fb() { // acceso a la form para insertar usuarios
    return this.formUsuarioBuscar.controls;
  }
  get fab() { // acceso a la form para insertar usuarios
    return this.formUsuarioBuscar;
  }

  constructor(
    private dataService: DataService,
    private notifier: NotifierService,
    private router:Router,
    public dialog:MatDialog,
    private authService: AuthService
  ) { 

    //Obtener los roles
    this.dataService.obtenerTiposUsuariosv2().subscribe(
      data => {
        this.rolesUsuario = data['data'];
      },
      error => {
        console.error(error);       
      }
    );

  }

  ngOnInit() {

    

    this.formUsuariosAgregar = new FormGroup({
      nombre_usuario: new FormControl('', [Validators.required]),
      email_usuario: new FormControl('', [Validators.required, Validators.email]),
      estatus_usuario: new FormControl(1, [Validators.required]),
      dep_usuario: new FormControl('', [Validators.required]),
      vip_usuario: new FormControl(0, [Validators.required]),
      puesto_usuario: new FormControl('', [Validators.required]),
      telefono_usuario: new FormControl(''),
      extension_usuario: new FormControl(''),
      id_jefatura: new FormControl(''),
      id_subsecretariaSap: new FormControl(''),
      id_dirgralSap: new FormControl('',[Validators.required]),
      id_areaSap:new FormControl('',[Validators.required]),
      Roles: new FormControl('', [Validators.required]),
      email_usuarioLogin: new FormControl('', [Validators.required, Validators.email]),
      //opcion: new FormControl(1),
      //direccion_areaUsuario: new FormControl('', [Validators.required]),
      //dirGral: new FormControl('', [Validators.required]),
    });
    this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
      this.formUsuariosAgregar.patchValue({
        email_usuarioLogin:user
      })
      //return this.emailUser;
    });

    this.formUsuarioBuscar=new FormGroup({
      email_usuario: new FormControl('', [Validators.required, Validators.email])
    });
    this.obtenerSubsecretarias();
    
    //Obtener las direcciones generales
    this.dataService.obtenerDireccionGral(0,this.emailUser).subscribe(data => {
      this.direccionesGral = data['data'];
    });
    

  }

  cancelar()
  {
    this.botonCancelar.emit(true);
    this.mostrarFormularioAgregar=false;
    //this.router.navigate(['./control-usuarios'])
    //this.router.navigate(['./administracion']);
  }

  //Abrir cuadro de dialogo
  openDialog ()
  {
    let dialogRef = this.dialog.open(ConfirmComponent,{data:`Correo no existente en registros SAP ¿Desea agregarlo?`,disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
        this.cancelar();
      }
      else{
        this.formUsuariosAgregar.patchValue({
          email_usuario:this.cadena,
          email_usuarioLogin:this.emailUser,
          estatus_usuario:true
        });
        this.mostrarBtnBusqueda=false;
      }
   });
  
  }

  limpiar()
  {
   this.formUsuarioBuscar.reset({email_usuario:""});
    this.formUsuariosAgregar.reset({ opcion: 1, vip_usuario: 0, estatus_usuario: 1, 
                                    nombre_usuario:"",email_usuario:"", dep_usuario:"",
                                    direccion_areaUsuario:"",puesto_usuario:"",Rol:""});
    while(!this.listaJefaturas.length) {this.listaJefaturas.pop();}
    this.dataService.obtenerTiposUsuariosv2().subscribe(data => {
                                                this.rolesUsuario = data['data'];
                                              },
                                              error => {
                                                console.error(error);       
                                              }
                                            );  

  }

  agregarQuitarRol(rol: string) 
  {
    let index = this.rolesSeleccionados.indexOf(rol);

    if (index !== -1) {
      this.rolesSeleccionados = this.rolesSeleccionados.filter(el => el !== rol);
    } else {
      this.rolesSeleccionados.push(rol);
    }
    this.formUsuariosAgregar.patchValue({
      Roles: this.rolesSeleccionados.toString()
    });
    let subse=this.formUsuariosAgregar.controls['Roles'].value;
    let posicion=subse.indexOf("11");
    //Verificamos si el rol es de tipo subsecretario
    if(posicion!== -1)
    {

      this.mostrarSubsecretaria=true;
    }
    else{
      this.mostrarSubsecretaria=false;
      this.formUsuariosAgregar.controls['id_subsecretariaSap'].reset();
      while(this.listaSubsecretarias.length) {
        this.listaSubsecretarias.pop();
      }
    }   
  }

  /*Método para obtener las jefaturas 
  obtenerJefaturas(user:Usuario)
  {
    this.dataService.obtenerJefaturas(user).subscribe(
      data => {
        this.listaJefaturas = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }*/

  //Método para obtener las subsecretarias 
  obtenerSubsecretarias()
  {
    this.dataService.getListSubsecretarias().subscribe(
      data => {
        this.listaSubsecretarias = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Método para obtener usuarios de base de datos SAP
  buscarPorUsuario()
  {
    this.dataService.buscarPorUsuario(this.formUsuarioBuscar.value).subscribe(res => {
      if (res['errorMessage']) 
      {
        this.notifier.notify('error','Ha ocurrido un error al intentar conectar con el server. Inténtalo nuevamente más tarde.');
      } else {

        switch (res['alert'].toString()) 
        {
          case '0':
           this.cadena=this.formUsuarioBuscar.value['email_usuario'].toString();
            //res['objData']['response']==0 ||
            if(this.cadena.split("@")[1] !="guanajuato.gob.mx")//Si la cuenta no es @guanajauto
            {
              //console.log(this.cadena.split("@")[1]);
              this.scrollInicio();
              this.openDialog();
              //this.notifier.notify('error', 'No existe usuario registrado en SAP con la cuenta especificada.');
            }else
            {
              if(res['objData']['response']==1)//Si existe en SAP
              {
              let infoUser: Usuario = res['objData'];
               //Llenar el combo de jefaturas
               //this.obtenerJefaturas(infoUser);
              this.mostrarFormularioAgregar=true;
              this.mostrarFormBusqueda=false;
              this.formUsuariosAgregar.patchValue({
                Roles: infoUser.roles,
                nombre_usuario: infoUser.nombre_usuario,
                puesto_usuario: infoUser.puesto_usuario,
                dep_usuario: infoUser.dep_usuario,
                vip_usuario: infoUser.vip_usuario,
                estatus_usuario: infoUser.estatus_usuario,
                //direccion_areaUsuario:infoUser.direccion_areaUsuario,
                id_areaSap:infoUser.id_areaSap,
                email_usuario:infoUser.email_usuario,
                id_dirgralSap:infoUser.id_dirgralSap
              });



             

             /* if(res['objData']['dirGral'].toUpperCase()=="DIRECCION GENERAL DE TECNOLOGIAS DE LA INFORMACION Y TELECOMUNICACIONES" ||
              res['objData']['dirGral'].toUpperCase()=="DIR. GRAL. DE TEC. DE INFORM. Y TELECOM.")
              {
                this.mostrarJefatura=true;               
              }*/
            }
            else{
              this.openDialog();
              //this.notifier.notify('error', 'No existe usuario registrado en SAP con la cuenta especificada.');
            }
              
            }
        }
      }
    });

  }

  //Método para hacer la validación de la subsecretaria
  validacionSubsecretaria()
  {
    
    let valorControl=this.formUsuariosAgregar.get('id_subsecretariaSap');
    let variableRetorno;
    if(valorControl===null){
      variableRetorno=false;
    }
    else{
      variableRetorno=true;
    }
    return variableRetorno;
  }


  
  //Método para los combos de areas del solicitante
  onChangeArea(areaGral: string) 
  {
    this.areaGralSeleccionada = areaGral;
    this.dataService.obtenerAreaSolicitante(parseInt(areaGral)).subscribe(
      data => {
        if (data['data']) {
          this.direccionesArea = data['data'];
        }
      },
      error => {
        console.log(error);
      }
    );
  }


  //Método para obtener las jefaturas
  onChangeJefatura(dirArea:string)
  {
    let area=parseInt(dirArea);
    if(area==3001 || area==3005 || area==3002)
    {
      this.mostrarJefatura=true;
      this.dataService.obtenerJefaturas(area).subscribe(
      data => {
        if (data['data']) {
          this.listaJefaturas = data['data'];
        }
      },
      error => {
        console.log(error);
      }
    );


    }
    else{
      this.mostrarJefatura=false;
    }

  }


  //Método para cargar las direcciones gral. dependiendo a la subsecretaria
  onChangeSubsecretaria(idSubse:number){
    this.subsecretaria = idSubse;
    this.dataService.getDirGralBySubsecretaria(this.subsecretaria).subscribe(
      data => {
        if (data['data']) {
          this.direccionesGralbySubse = data['data'];
        }
      },
      error => {
        console.log(error);
      }
    );


  }

  
  insertUsuario()
  {
    this.loadingGeneral=true;
    this.dataService.insertarUsuarioV2(this.formUsuariosAgregar.value).subscribe(res => {
      if (res['errorMessage']) 
      {
        this.notifier.notify('error', 'Ha ocurrido un error al intentar conectar con el server. Inténtalo nuevamente más tarde.');
      } else {
        //this.notifier.notify('success', 'Usuario guardado correctamente.');
        switch (res['alert'].toString()) {
          case '0':
            if(res['objData']['response']==1)
            {
              this.mostrarFormBusqueda=true;
              this.mostrarFormularioAgregar=false;
              this.areaGralSeleccionada="0";
              this.mostrarBtnBusqueda=true;
              this.scrollInicio();
              this.notifier.notify('error', 'Ya existe un usuario registrado con la cuenta especificada.');
              this.rolesSeleccionados=[];
              this.direccionesArea=[];
              this.loadingGeneral=false;
              this.formUsuariosAgregar.reset();
              this.formUsuarioBuscar.reset();
              
              this.formUsuariosAgregar.patchValue({
                email_usuarioLogin: this.emailUser
              });

              /*this.formUsuarioBuscar.reset({email_usuario:""});
              this.formUsuariosAgregar.reset({ opcion: 1,vip_usuario: 0, estatus_usuario: 1, 
                                            nombre_usuario:"",email_usuario:"", dep_usuario:"",
                                            direccion_areaUsuario:"",puesto_usuario:"",Roles:""});
                                           /* while(this.listaJefaturas.length) {
                                              this.listaJefaturas.pop();
                                            }*/
                                            this.dataService.obtenerTiposUsuariosv2().subscribe(
                                              data => {
                                                this.rolesUsuario = data['data'];
                                              },
                                              error => {
                                                console.error(error);       
                                              }
                                            );                                           
              break;
            }else{
            this.mostrarFormBusqueda=true;
            this.mostrarFormularioAgregar=false;
            this.mostrarBtnBusqueda=true;
            this.areaGralSeleccionada="0";
            this.scrollInicio();
            this.notifier.notify('success', 'Usuario registrado correctamente.');
            this.rolesSeleccionados=[];
            this.direccionesArea=[];
            this.loadingGeneral=false;
            this.formUsuariosAgregar.reset();
            this.formUsuarioBuscar.reset();

            
              this.formUsuariosAgregar.patchValue({
                email_usuarioLogin: this.emailUser
              });

           /*this.formUsuarioBuscar.reset({email_usuario:""});
            this.formUsuariosAgregar.reset({ opcion: 1,vip_usuario: 0, estatus_usuario: 1, 
                                            nombre_usuario:"",email_usuario:"", dep_usuario:"",
                                            direccion_areaUsuario:"",puesto_usuario:"",Rol:""});*/
                                            /*while(this.listaJefaturas.length) {
                                              this.listaJefaturas.pop();
                                            }*/
                                            
                                            this.dataService.obtenerTiposUsuariosv2().subscribe(
                                              data => {
                                                this.rolesUsuario = data['data'];
                                              },
                                              error => {
                                                console.error(error);       
                                              }
                                            );                                                                              
            }
            break;
          case '1':      
            this.mostrarFormBusqueda=true;
            this.mostrarFormularioAgregar=false;
            this.mostrarBtnBusqueda=true;
            this.areaGralSeleccionada="0";
            this.scrollInicio();
            this.notifier.notify('error', res['notificaciones']);
            this.rolesSeleccionados=[];
            this.direccionesArea=[];
            this.loadingGeneral=false;
            this.formUsuariosAgregar.reset();
            this.formUsuarioBuscar.reset();

            
              this.formUsuariosAgregar.patchValue({
                email_usuarioLogin: this.emailUser
              });

            break;
      }
        
      }
    }, error => {
      console.error(error);
      this.notifier.notify('error', 'No se ha podido guardar el usuario. Revisa tu conexión de red.');
    });
  }


  scrollInicio() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // pasos cada intervalo
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }
}
